import { useContent } from "@/context/ContentContext";
import Biography from "@/components/site/Biography";
import OriginDeepDive from "@/components/site/OriginDeepDive";
import VerzuzFeature from "@/components/site/VerzuzFeature";
import PageLoader from "@/components/site/PageLoader";

export default function BiographyPage() {
  const c = useContent();
  if (!c) return <PageLoader />;
  return (
    <>
      <Biography chapters={c.bio || []} />
      <OriginDeepDive />
      <VerzuzFeature />
    </>
  );
}
